import { render, staticRenderFns } from "./ImageCropper.vue?vue&type=template&id=673bcc5a&"
import script from "./ImageCropper.vue?vue&type=script&lang=js&"
export * from "./ImageCropper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports